import { InjectionToken, Signal } from '@angular/core';

import { KrosFormFieldControl } from './kros-form-field-control';
import { KrosInputError } from './kros-error.directive';

export interface KrosFormFieldHost {
  addClass(className: string): void;
  removeClass(className: string): void;
  addStyle(styleName: string, value: string): void;
  removeStyle(styleName: string): void;
  control: KrosFormFieldControl<any>;
  errorChildren: Signal<KrosInputError[]>;
}

export const KROS_FORM_FIELD_HOST = new InjectionToken<KrosFormFieldHost>('KrosFormFieldHost');
